module.exports = __webpack_public_path__ + "static/media/jenni-lee.870d5545.jpg";